import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { AxiosError } from 'axios';
import { showError, showSuccess } from '../../../../utils/Notifications';
import { LandscapeSupportersResponseDto } from '../dto/response/landscape-suporters-response.dto';
import landscapeSupportesService from '../services/landscape-supporters.service';
// import { LandscapeSupportersUpdateRequestDto } from '../dto/request/landscape-supporters-update-request.dto';
import { LandscapeSupportersSaveRequestDto } from '../dto/request/landscape-suporters-save-request.dto';

const initialState = {
  status: 'idle',
  compactSupporters: [] as LandscapeSupportersResponseDto[] | null,
  compactSupporter: {} as LandscapeSupportersResponseDto | null,
  error: null as string | null,
};

export const fetchCompactSupportersByOrganizationId = createAsyncThunk(
  'compactSupporters/fetchCompactSupportersByOrganizationId',
  async (organizationId: string) => {
    return await landscapeSupportesService.fetchCompactSupportersByOrganizationId(
      organizationId
    );
  }
);

// export const fetchCompactSupportersById = createAsyncThunk(
//   'compactSupporters/fetchCompactSupportersById',
//   async (compactSupporterId: string) => {
//     return await landscapeSupportesService.fetchCompactSupportersById(
//       compactSupporterId
//     );
//   }
// );

// export const fetchCompactSupportersConsortiumsByLandscapeId = createAsyncThunk(
//   'compactSupporters/fetchCompactSupportersConsortiumsByLandscapeId',
//   async (landcscapeId: string) => {
//     return await landscapeSupportesService.fetchCompactSupportersConsortiumsByLandscapeId(
//       landcscapeId
//     );
//   }
// );

// export const fetchCompactSupportersConvenersByLandscapeId = createAsyncThunk(
//   'compactSupporters/fetchCompactSupportersConvenersByLandscapeId',
//   async (landcscapeId: string) => {
//     return await landscapeSupportesService.fetchCompactSupportersConvenersByLandscapeId(
//       landcscapeId
//     );
//   }
// );

export const fetchCompactSupportersByLandscapeId = createAsyncThunk(
  'compactSupporters/fetchCompactSupportersByLandscapeId',
  async (landcscapeId: string) => {
    return await landscapeSupportesService.fetchCompactSupportersByLandscapeId(
      landcscapeId
    );
  }
);

export const saveCompactSupporter = createAsyncThunk(
  'compactSupporters/saveCompactSupporters',
  async (
    saveRequest: LandscapeSupportersSaveRequestDto,
    { rejectWithValue }
  ) => {
    try {
      return await landscapeSupportesService.saveCompactSupporter(saveRequest);
    } catch (e) {
      return rejectWithValue((e as AxiosError).response?.data ?? 'Failed');
    }
  }
);

// export const updateCompactSupporters = createAsyncThunk(
//   'compactSupporters/updateCompactSupporters',
//   async (
//     updateRequest: LandscapeSupportersUpdateRequestDto,
//     { rejectWithValue }
//   ) => {
//     try {
//       return await landscapeSupportesService.updateCompactSupporters(
//         updateRequest
//       );
//     } catch (e) {
//       return rejectWithValue((e as AxiosError).response?.data ?? 'Failed');
//     }
//   }
// );

export const deleteCompactSupporter = createAsyncThunk(
  'compactSupporters/deleteCompactSupporters',
  async (existingId: string, { rejectWithValue }) => {
    try {
      await landscapeSupportesService.deleteCompactSupporter(existingId);
    } catch (e) {
      return rejectWithValue((e as AxiosError).response?.data ?? 'Failed');
    }
  }
);

const compactSupportersSlice = createSlice({
  name: 'compactSupportersSlice',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchCompactSupportersByOrganizationId.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(
        fetchCompactSupportersByOrganizationId.fulfilled,
        (state, action) => {
          state.status = 'succeeded';
          state.compactSupporters = action.payload;
        }
      )
      .addCase(
        fetchCompactSupportersByOrganizationId.rejected,
        (state, action) => {
          state.status = 'failed';
          state.error = action.error?.message ?? null;
        }
      )
      // .addCase(fetchCompactSupportersById.pending, (state) => {
      //   state.status = 'loading';
      // })
      // .addCase(fetchCompactSupportersById.fulfilled, (state, action) => {
      //   state.status = 'succeeded';
      //   state.compactSupporter = action.payload;
      // })
      // .addCase(fetchCompactSupportersById.rejected, (state, action) => {
      //   state.status = 'failed';
      //   state.error = action.error?.message ?? null;
      // })
      // .addCase(
      //   fetchCompactSupportersConsortiumsByLandscapeId.pending,
      //   (state) => {
      //     state.status = 'loading';
      //   }
      // )
      // .addCase(
      //   fetchCompactSupportersConsortiumsByLandscapeId.fulfilled,
      //   (state, action) => {
      //     state.status = 'succeeded';
      //     state.compactSupporter = action.payload;
      //   }
      // )
      // .addCase(
      //   fetchCompactSupportersConsortiumsByLandscapeId.rejected,
      //   (state, action) => {
      //     state.status = 'failed';
      //     state.error = action.error?.message ?? null;
      //   }
      // )
      // .addCase(
      //   fetchCompactSupportersConvenersByLandscapeId.pending,
      //   (state) => {
      //     state.status = 'loading';
      //   }
      // )
      // .addCase(
      //   fetchCompactSupportersConvenersByLandscapeId.fulfilled,
      //   (state, action) => {
      //     state.status = 'succeeded';
      //     state.compactSupporter = action.payload;
      //   }
      // )

      .addCase(
        fetchCompactSupportersByLandscapeId.rejected,
        (state, action) => {
          state.status = 'failed';
          state.error = action.error?.message ?? null;
        }
      )
      .addCase(fetchCompactSupportersByLandscapeId.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(
        fetchCompactSupportersByLandscapeId.fulfilled,
        (state, action) => {
          state.status = 'succeeded';
          state.compactSupporters = action.payload;
        }
      )
      // .addCase(
      //   fetchCompactSupportersConvenersByLandscapeId.rejected,
      //   (state, action) => {
      //     state.status = 'failed';
      //     state.error = action.error?.message ?? null;
      //   }
      // )
      .addCase(saveCompactSupporter.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(saveCompactSupporter.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.compactSupporters?.push(action.payload);
        showSuccess('Landscape added successfully.');
      })
      .addCase(saveCompactSupporter.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload as string;
        showError(`Adding landscape failed. ${action.payload as string}`);
      })
      // .addCase(updateCompactSupporters.pending, (state) => {
      //   state.status = 'loading';
      // })
      // .addCase(updateCompactSupporters.fulfilled, (state, action) => {
      //   state.status = 'succeeded';
      //   showSuccess('Landscape saved successfully.');
      //   state.compactSupporter = action.payload;
      // })
      // .addCase(updateCompactSupporters.rejected, (state, action) => {
      //   state.status = 'failed';
      //   state.error = action.payload as string;
      //   showError(`Saving landscape failed. ${action.payload as string}`);
      // })
      .addCase(deleteCompactSupporter.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(deleteCompactSupporter.fulfilled, (state) => {
        state.status = 'succeeded';
        showSuccess('Landscape deleted successfully.');
      })
      .addCase(deleteCompactSupporter.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload as string;
        showError(`Deleting landscape failed. ${action.payload as string}`);
      });
  },
});

export default compactSupportersSlice.reducer;
